import valuer_api from "../../api/valuer";
import {useEffect, useState} from "react";
import ValuerAmendFieldListHandler from "./ValuerAmendFieldListHandler";
import DateRangePickerDialog from "../DateRangePickerDialog";
import DatePicker from "react-datepicker";


const ValuerAmendPriceInput = (props) => {

    // For Saving
    const summaryId = props.summaryId
    const section = props.sectionName
    const identifier = props.identifier

    // Optional
    const field = props.field
    const rowId = props.rowId ? props.rowId : false

    // Sizing
    const width = props.width ? props.width : '100%'
    const height = props.height ? props.height : '100%'
    const minHeight = props.minHeight ? props.minHeight : '48px'
    const minWidth = props.minWidth ? props.minWidth : '0'

    // Value
    const [value, setValue] = useState(null)

    // Additional Fields
    const showValueDependantFields = props.showValueDependantFields ? props.showValueDependantFields : false
    const valueDependantFields = props.valueDependantFields ? props.valueDependantFields : []

    // Saving Tracker
    const UpdateParentValue = props.UpdateParentValue
    const AddToQueue = props.AddToQueue
    const RemoveFromQueue = props.RemoveFromQueue
    const AddToErroredSaves = props.AddToErroredSaves

    // Error Handling
    const setErrorMessage = props.setErrorMessage
    const setErrorTitle = props.setErrorTitle

    useEffect(() => {
        if (props.value !== undefined) setValue(props.value)
    }, [props.value])

    const UpdateValue = () => {
        let updateTime = Date.now()
        AddToQueue(section, identifier, updateTime)
        let body = { "value": value}
        if (rowId) body["row"] = rowId
        UpdateParentValue(identifier, value, rowId)
        let response = valuer_api.ValuerAmendPut(summaryId, section, identifier, body);
        response.then(
            response => {
                RemoveFromQueue(section, identifier, updateTime)
            }
        ).catch((err) => {
            AddToErroredSaves(section, identifier, updateTime)
            setErrorTitle("Failed to Save")
            setErrorMessage("The request to save a field has failed")
        })
    }

    const ClickOff = () => {
        // Check for required fields and then submit change
        if (!summaryId || !section || !identifier) return
        UpdateValue()
    }

    const handleValuationChange = (ev) => {
        if (!ev.target.value) {
            setValue(null)
            return
        }
        let v = Number(ev.target.value.replace(/[^0-9]+/g,""));
        setValue(v);
    }

    return (
        <>
            <div className="valuer-amend-price-field-container" style={{width: width, minWidth: minWidth}}>
                {field && field
                    ? <div className="valuer-amend-field-label"> {field} </div>
                    : null
                }
                <div className="valuer-amend-field-input-container"
                     style={{width: width, height: height, minHeight: minHeight, minWidth: minWidth}}>
                    <div className="valuer-amend-field-label-pound">£</div>
                    <input type='text' value={value && value.toLocaleString()} className="valuer-amend-field"
                           onChange={handleValuationChange} onBlur={() => ClickOff()}/>
                </div>
            </div>
            {valueDependantFields && valueDependantFields.map((fields, idx) => {
                return (
                    <>
                        {value && (fields.requirement && value === fields.requirement.value)
                        || value && (fields.antiRequirement && value !== fields.antiRequirement.value)
                            ? <ValuerAmendFieldListHandler fieldList={fields.fields}
                                                           sectionName={section}
                                                           summaryId={summaryId}
                                                           setErrorMessage={setErrorMessage}
                                                           setErrorTitle={setErrorTitle}
                                                           UpdateParentValue={UpdateParentValue}
                                                           AddToQueue={AddToQueue}
                                                           RemoveFromQueue={RemoveFromQueue}
                                                           AddToErroredSaves={AddToErroredSaves}/>

                            : (showValueDependantFields ?
                                <div className="valuer-amend-disabled-container">
                                    <ValuerAmendFieldListHandler fieldList={fields.fields}
                                                                 sectionName={section}
                                                                 summaryId={summaryId}
                                                                 setErrorMessage={setErrorMessage}
                                                                 setErrorTitle={setErrorTitle}
                                                                 UpdateParentValue={UpdateParentValue}
                                                                 AddToQueue={AddToQueue}
                                                                 RemoveFromQueue={RemoveFromQueue}
                                                                 AddToErroredSaves={AddToErroredSaves}/>
                                </div>
                                : null)
                        }
                    </>
                )
            })}
        </>
    )

}

export default ValuerAmendPriceInput